import { DayOfWeek } from "../types/ClinicHours";

export const SK_MON_SHORT = ["JAN", "FEB", "MAR", "APR", "MÁJ", "JÚN", "JÚL", "AUG", "SEP", "OKT", "NOV", "DEC"];
export const SK_MON = ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"];
export const SKDAYS_LC = ["pondelok", "utorok", "streda", "štvrtok", "piatok", "sobota", "nedeľa"];
export const SK_DOW = ["po", "ut", "st", "št", "pi", "so", "ne"];
export const DAY_SHORT: Record<string, string> = {
  monday: "Po", tuesday: "Ut", wednesday: "St",
  thursday: "Št", friday: "Pi", saturday: "So", sunday: "Ne",
};

export const DAY_LABELS: Record<DayOfWeek, string> = {
  monday: "Pondelok",
  tuesday: "Utorok",
  wednesday: "Streda",
  thursday: "Štvrtok",
  friday: "Piatok",
  saturday: "Sobota",
  sunday: "Nedeľa",
};

export const DAY_ORDER: DayOfWeek[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const DAYS: { key: DayOfWeek; label: string }[] = [
  { key: "monday", label: "Pondelok" },
  { key: "tuesday", label: "Utorok" },
  { key: "wednesday", label: "Streda" },
  { key: "thursday", label: "Štvrtok" },
  { key: "friday", label: "Piatok" },
  { key: "saturday", label: "Sobota" },
  { key: "sunday", label: "Nedeľa" },
];
